import { environment } from "../../../environment";
export const tasksUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks`
    : `https://middleware.uat.farther.com/task/${version}/tasks`;
export const taskTemplateUrl = (templateId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/v1/templates/${templateId}`
    : `https://middleware.uat.farther.com/task/v1/templates/${templateId}`;
export const taskTypeTemplateUrl = (taskType) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/v1/templates/taskType/${taskType}`
    : `https://middleware.uat.farther.com/task/v1/templates/taskType/${taskType}`;
export const searchParametersUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks/parameters/search`
    : `https://middleware.uat.farther.com/task/${version}/tasks/parameters/search`;
export const taskTypesUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks/types`
    : `https://middleware.uat.farther.com/task/${version}/tasks/types`;
export const taskUrl = (version, taskId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks/${taskId}`
    : `https://middleware.uat.farther.com/task/${version}/tasks/${taskId}`;
export const taskParentUrl = (version, taskId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks/${taskId}/parent`
    : `https://middleware.uat.farther.com/task/${version}/tasks/${taskId}/parent`;
//# sourceMappingURL=urls.js.map